export interface ToleranceRangeResponse {
  examTaskGroup: ToleranceRangeTaskGroup[] | ToleranceRangeTaskGroup;
}

export interface ToleranceRangeTaskGroup {
  examTaskGroupId: string;
  examTaskGroupName: string;
  toleranceRange: ToleranceRange | null;
  task: ToleranceRangeTask[];
  isProcessRequired: boolean;
}

export interface ToleranceRangeTask {
  taskId: string;
  taskNumber: string;
  toleranceRange: ToleranceRange | null;
  criterion: ToleranceRangeCriterion[];
}

export interface ToleranceRangeCriterion {
  criterionId: string;
  criterionName: string;
  toleranceRange: ToleranceRange | null;
  scores: number[];
}

export interface ToleranceRange {
  toleranceRangeValue: number;
  toleranceRangeType: ToleranceType;
  isActive: boolean;
}

export enum ToleranceType {
  RelativeDifference,
  AbsoluteDifference,
}

export interface ToleranceRangeRow {
  id: string;
  fieldType: string;
  label: string;
  value: number;
  type: ToleranceType;
  hasSingleItemChildren: boolean;
  parentId: string;
  isActive: boolean;
  isProcessRequired?: boolean;
  scores: number[];
}

export interface ToleranceRangeChange {
  toleranceRange: ToleranceRange | null;
  task: Task[];
}

export interface Task {
  taskId: string;
  toleranceRange: ToleranceRange | null;
  criterion: Criterion[];
}

export interface Criterion {
  criterionId: string;
  toleranceRange: ToleranceRange;
}
